(function () {
    "use strict";

    angular
        .module("showcaseApp")
        .component("flyerImportsList", {
            templateUrl:
                "app/admin/flyers/import/flyer-imports-list/flyer-imports-list.html",
            controller: FlyerImportsListController,
            bindings: {
                flyerImportsList: "<",
                totalImports: "<",
                numPerPage: "<?",
                onChangePage: "&?"
            },
        });

    /** @ngInject */
    function FlyerImportsListController($window, systemConstants, $scope) {
        var $ctrl = this;

        $ctrl.onChangePage = $ctrl.onChangePage || angular.noop;
        $ctrl.totalImports = $ctrl.totalImports || 0;
        $ctrl.numPerPage = $ctrl.numPerPage || 10;

        $ctrl.$onInit = init;
        $ctrl.changePage = changePage;

        function init() {
            $ctrl.currentPage = 1;
            $ctrl.maxSize = 5;
            $ctrl.startRegistry = 0;
            $ctrl.endRegistry = 0;

            updateDisplayState();
            watchImportList();
        }

        function changePage() {
            $ctrl.onChangePage({page: $ctrl.currentPage});
        }

        function updateDisplayState() {
            $ctrl.isMobile = $window.innerWidth <= systemConstants.BOOTSTRAP_RESOLUTIONS.MIN_SM;

            if (!$ctrl.isMobile) {
                $ctrl.showflyerImportsList = true;
            }
        }

        function watchImportList() {
            $scope.$watchGroup(['$ctrl.flyerImportsList', '$ctrl.totalImports'], function() {
                var apiPage = $ctrl.currentPage - 1;

                if ($ctrl.totalImports === 0) {
                    $ctrl.startRegistry = 0;
                    $ctrl.endRegistry = 0;
                } else {
                    $ctrl.startRegistry = (apiPage * $ctrl.numPerPage) + 1;
                    $ctrl.endRegistry = $ctrl.startRegistry + $ctrl.flyerImportsList.length - 1;
                }
            });
        }
    }
})();
